import { reactive } from 'vue';

// App-owned state for the shared SupportRequestDialog (ADR 0021). Opened from the
// sidebar Support button or a hard error's "contact support" action (the caller may
// pass that error's correlationId as `reference`). The dialog is headless — the
// host component (SupportRequestDialogHost) owns the submit. Single shared instance.
interface SupportState {
  open: boolean;
  reference?: string;
  busy: boolean;
}

const state = reactive<SupportState>({ open: false, busy: false });

export function useSupport() {
  function open(reference?: string) {
    state.reference = reference;
    state.open = true;
    state.busy = false;
  }
  function close() {
    state.open = false;
    state.reference = undefined;
    state.busy = false;
  }
  return { state, open, close };
}
